import script from "./Catalogue.vue?vue&type=script&setup=true&lang=js"
export * from "./Catalogue.vue?vue&type=script&setup=true&lang=js"

import "./Catalogue.vue?vue&type=style&index=0&id=a2cd8a9c&lang=css"

const __exports__ = script;

export default __exports__